export const INTERNAL_PATH_QUERY_PARAMETER = 'digitalDealerPath';
